module.exports = __webpack_public_path__ + "img/svg/star-filled.1c8ac7ac4675f26bf9f087bf1f232915.svg";